export default "__VITE_ASSET__BMe2MtlY__"